'use client';

import {useTranslations} from 'next-intl';
import {useMemo} from 'react';
import {Button} from '../../../../../../components/design-system';
import useFilters from '../hooks/useFilters';
import FilterCategory from './FilterCategory';
import FilterCharacteristic from './FilterCharacteristic';
import FilterLocation from './FilterLocation';
import FilterOccasion from './FilterOccasion';
import FilterPrice from './FilterPrice';
import FilterSort from './FilterSort';

export default function FilterBar() {
  const t = useTranslations('shop');

  const {filters, reset} = useFilters();

  const hasFiltersApplied = useMemo(() => {
    const count =
      (filters.category || []).length +
      (filters.subcategory || []).length +
      (filters.country || []).length +
      (filters.region || []).length +
      (filters.occasion || []).length +
      (filters.characteristic || []).length +
      (filters.priceMin ? 1 : 0) +
      (filters.priceMax ? 1 : 0);
    return count > 0;
  }, [
    filters.category,
    filters.subcategory,
    filters.country,
    filters.region,
    filters.priceMin,
    filters.priceMax,
    filters.occasion,
    filters.characteristic,
  ]);

  return (
    <div
      className={`
    tw-container tw-mx-auto tw-flex tw-flex-nowrap tw-items-center tw-gap-2
    tw-px-4 lg:tw-px-6 xl:tw-px-8 tw-overflow-x-auto md:tw-overflow-visible
  `}
    >
      {hasFiltersApplied && (
        <>
          <Button
            className="tw-text-sm tw--mx-2"
            size="sm"
            theme="ghost"
            onClick={() => reset()}
          >
            {t('filter.reset')}
          </Button>
          <div className="tw-w-px tw-shrink-0 tw-h-6 tw-bg-greyscale-separator" />
        </>
      )}
      <FilterCategory />
      <FilterPrice />
      <FilterLocation />
      <FilterCharacteristic />
      <FilterOccasion />
      <FilterSort />
    </div>
  );
}
